import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast';
import { updateAlertSettings } from 'services/apiAlert';

const useUpdateAlertSettings = () => {
  const queryClient = useQueryClient();

  const {isPending:isUpdating,isSuccess:isUpdated,isError:isUpdateError, mutate:updateAlertSettingsAPI} = useMutation({
    mutationFn: updateAlertSettings,
    onSuccess: (data)=>{
        queryClient.invalidateQueries({queryKey:['alertSettings']})
        toast.success("Settings Updated...")
    },
    onError:(error)=>{
        console.log("Error occurred while updating alert settings",error)
        if(error?.data && typeof error.data === 'object'){
            for (const key in error.data){
                const msg = error.data[key];
                toast.error(Array.isArray(msg) ? msg[0] : msg)
            }
        }else{
            toast.error(error.message || "Something went wrong")
        }
    }
  })

  return{isUpdating,isUpdated,isUpdateError,updateAlertSettingsAPI}
}

export default useUpdateAlertSettings
